import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const KpiCard = styled.div`
	width: 100%;
	padding: 1em;
	margin: 0.5%;
	background-color: ${colors.white};
	box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
`;

export const CardValue = styled.div`
	display: block;
	font-size: 150%;
	font-weight: bolder;
	color: ${colors.chartDarkTeal};
`;

export const CardText = styled.div`
	display: block;
	font-size: 65%;
	padding-left: 0.2em;
`;
export const IconWrapper = styled.div`
	background-color: ${colors.blue100};
	border-radius: 50%;
	width: 50px;
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
`;
